import React from "react";
import { Modal } from "@material-ui/core";
import Form from "../Form";

const EditShipment = (props) => {
  const { open, onClose, reloadFunc, id, data } = props;

  const modalStyle = {
    height: '100vh',
    width: '80%',
    marginRight: '10%',
    marginLeft: '10%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  };

  const contentStyle = {
    backgroundColor: 'white',
    padding: '2%',
    border: "none",
    overflow: 'auto',
    maxHeight: '80vh',
  };

  return (
    <Modal
      open={open}
      style={modalStyle}
      onClose={onClose}
    >
      <div style={contentStyle}>
        <Form reloadFunc={reloadFunc} onClose={onClose} data={data || undefined} id={id} edit={true} />
      </div>
    </Modal>
  );
};

export default EditShipment;



// import React from "react";
// import { TextField, Grid, useTheme, Typography, Modal, Backdrop } from "@material-ui/core";
// import Autocomplete from "@material-ui/lab/Autocomplete";
// import { RTL } from "../../../../components";
// import AlertInfo from "components/AlertInfo";
// import Form from "../Form";

// const EditShipment = (props) => {
//   const { open, onClose, title, reloadFunc, onAccept, id, data, ...rest } = props;
//   const theme = useTheme();


//   return (
//     <>
//       <Modal
//         open={open}
//         style={{
//           Height: '100vh', width: '80%', marginRight: '10%', marginLeft: '10%', display: 'flex',
//           justifyContent: 'center',
//           alignItems: 'center',
//         }}

//         onClose={onClose}
//       >
//         <div style={{
//           backgroundColor: 'white', padding: '2%', border: "none",
//         }}>
//           <Form reloadFunc={reloadFunc} onClose={onClose} data={data || undefined} id={id} edit={true} />

//         </div>
//       </Modal>


//       {/* <AlertInfo
//         fullWidth={true}
//         onClose={onClose}
//         onAccept={onAccept}
//         {...rest}
//         maxWidth={"sm"}
//         title={props.title}
//         open={open}
//       >
//        <Form edit={true}/>
//       </AlertInfo> */}
//     </>
//   );
// };

// export default EditShipment;
